import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContractTypesService } from 'src/app/services/contracttypes.service';
import { ContracttypesModalComponent } from './contracttypes-modal/contracttypes-modal.component';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';

@Component({
  selector: 'app-contracttypes',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './contracttypes.component.html',
  styleUrls: ['./contracttypes.component.css']
})
export class ContractTypesComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private ContractTypesService: ContractTypesService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  ContractTypesList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getContractTypes();
  }

  getContractTypes(){
    this.ContractTypesService.getContractTypes().subscribe({
      next: (res: any) => {
        this.ContractTypesList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al cargar tipos de contrato:', err);
        this.filteredData = [];
      }
    });
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(ContracttypesModalComponent, {
      data: { item, mode, title },
      maxWidth: '100%',
      width: '40%',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getContractTypes();
        }
      }
    });
  }

}
